import { render, staticRenderFns } from "./AssetContext.vue?vue&type=template&id=66511550&scoped=true&"
import script from "./AssetContext.vue?vue&type=script&lang=js&"
export * from "./AssetContext.vue?vue&type=script&lang=js&"
import style0 from "./AssetContext.vue?vue&type=style&index=0&id=66511550&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66511550",
  null
  
)

export default component.exports